import React from 'react'
import PropTypes from 'prop-types'
import { FieldLabel, FilteredSelect, Placeholder, Select } from 't3-widgets'
import { DeviceTypeHandler } from '../../../../../../../../common/components/device-type-handler/device-type-handler'
import { MobileNativeSelect } from '../../../../../../../../common/components/mobile-native-select/mobile-native-select'

import styles from './select-vehicle.module.css'

const GenerationChooseItem = ({
    children,
    filtered,
    hidden,
    intl,
    label,
    mobileMappedOptions,
    onChange,
    placeholderValue,
    skipValidation,
    validationError,
    value
}) => {
    const props = {
        className: styles['select-field'],
        disabled: skipValidation,
        error: validationError,
        filterPlaceholder: intl.translate('ap_select_filtered_search') + '...',
        key: 'wf-sub-model',
        onChange,
        placeholder: intl.translate('ap_select_placeholder'),
        placeholderValue,
        value
    }

    const desktopDeviceComponent = filtered ? (
        <FilteredSelect {...props}>
            <Placeholder>{intl.translate('ap_select_placeholder')}</Placeholder>
            {children}
        </FilteredSelect>
    ) : (
        <Select {...props}>{children}</Select>
    )

    const mobileDeviceComponent = (
        <div className={styles['select-field']}>
            <MobileNativeSelect {...props}>{mobileMappedOptions}</MobileNativeSelect>
        </div>
    )

    if (hidden) {
        return <span />
    } else {
        return (
            <div className={styles['generation-choose-item']}>
                <div className={styles['input-field']}>
                    <FieldLabel {...{ label }}>
                        <DeviceTypeHandler {...{ desktopDeviceComponent, mobileDeviceComponent }} />
                    </FieldLabel>
                </div>
            </div>
        )
    }
}

GenerationChooseItem.propTypes = {
    filtered: PropTypes.boolean,
    hidden: PropTypes.boolean,
    intl: PropTypes.objectOf(PropTypes.func),
    label: PropTypes.string,
    mobileMappedOptions: PropTypes.array,
    onChange: PropTypes.func,
    placeholderValue: PropTypes.string,
    skipValidation: PropTypes.boolean,
    validationError: PropTypes.string,
    value: PropTypes.string
}

export { GenerationChooseItem }
